export const rpcUrl = 'https://web3.euc.li/v1/mainnet'
